import { Action, createReducer } from 'typesafe-actions';
import { TpaParamsState } from '../../types/ReduxMisc';
import { setTpaParams } from '../actions/setTpaParams';

const initialState: TpaParamsState = {};

export const tpaParamsReducer = createReducer<TpaParamsState, Action>(
  initialState
).handleAction(setTpaParams, (tpaParamsState, action) => action.payload);
